
import { END_POINTS } from "../helpers";
import emptySplitApi from "../utils/rtk";

type CommonResponse = {
    statusCode: number;
    message?: string;
    data?: any;
};
export const chatApi = emptySplitApi.injectEndpoints({
    endpoints: (builder) => ({
        createRoom: builder.mutation<CommonResponse & { data: any }, any>({
            query: (body) => ({
                url: `${END_POINTS.chatList}`,
                method: "POST",
                body,
            }),
            invalidatesTags: ["CHATS"],
        }),

        getMyChats: builder.query<CommonResponse & { data: any }, { search?: string }>({
            query: (params) => {
                const newParams: any = { ...params };
                if (!newParams.search) delete newParams.search;
                return {
                    url: `${END_POINTS.chatList}`,
                    method: "GET",
                    params: newParams,
                };
            },
            providesTags: ["CHATS"],
        }),

        getRoomMessages: builder.query<
            CommonResponse & { data: any; page: number },
            { roomId: string; page: number; limit?: number }
        >({
            query: ({ roomId, page, limit = 15 }) => ({
                url: `${END_POINTS.chatList}/${roomId}?page=${page}&limit=${limit}`,
                method: "GET",
            }),
        }),

        deleteChat: builder.mutation<CommonResponse, string>({
            query: (roomId) => ({
                url: `${END_POINTS.deleteChat}/${roomId}`,
                method: "DELETE",
            }),
            invalidatesTags: ["CHATS"],
        }),
    }),
});

export const {
    useCreateRoomMutation,
    useGetMyChatsQuery,
    useGetRoomMessagesQuery,
    useDeleteChatMutation,
} = chatApi;
